











































import { Component, Vue, Watch } from 'vue-property-decorator'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { buscarNovidadeDoChat, chatDeSuporteConfigurado, marcarNovidadeDoChatComoVista } from '@/api/suporteChat'
import { ChatDeSuporteModule } from '@/store/vuex/suporte/ChatDeSuporteStore'
import { Caixa, posicaoDoBalaoDeNovidade } from '@/shareds/chat-de-suporte'

const PROCURA_DO_ICONE_MS = 700
const FOLGA_DO_FOCO = 6

/**
 * Destaque de novidade do chat de suporte: enquanto o usuário não abriu o chat nem clicou em "Entendi", a tela
 * escurece em volta do ícone da barra e fica travada até o "Entendi". O "já viu" fica no ERP, por usuário, e vale
 * em qualquer computador.
 */
@Component
export default class DestaqueDoChatDeSuporte extends Vue {
	configurado = chatDeSuporteConfigurado()
	// O que o ERP respondeu, e para qual usuário. Sem resposta (consultando ou erro), o destaque não aparece.
	respostaDoServidor: { dono: string; vista: boolean } | null = null
	vistosNestaAba: string[] = []
	alvo: Caixa | null = null
	larguraDaTela = window.innerWidth
	procura?: number

	get dono(): string | null {
		return (UserLoginStore.usuario && UserLoginStore.usuario.id) || null
	}

	get jaViu(): boolean {
		const dono = this.dono
		if (!dono || this.vistosNestaAba.includes(dono)) return true
		const resposta = this.respostaDoServidor
		return !resposta || resposta.dono !== dono || resposta.vista
	}

	get painelAberto() {
		return ChatDeSuporteModule.painelAberto
	}

	get elegivel() {
		return this.configurado && !this.jaViu && !this.painelAberto
	}

	get visivel() {
		return this.elegivel && this.alvo !== null
	}

	get escuro() {
		return this.$vuetify.theme.dark
	}

	get posicao() {
		return this.alvo
			? posicaoDoBalaoDeNovidade(this.alvo, this.larguraDaTela)
			: { top: 0, left: 0, largura: 0, seta: 0 }
	}

	get estiloDoFoco() {
		const alvo = this.alvo
		if (!alvo) return {}
		return {
			top: `${alvo.top - FOLGA_DO_FOCO}px`,
			left: `${alvo.left - FOLGA_DO_FOCO}px`,
			width: `${alvo.width + 2 * FOLGA_DO_FOCO}px`,
			height: `${alvo.height + 2 * FOLGA_DO_FOCO}px`,
		}
	}

	get estiloDoBalao() {
		return { top: `${this.posicao.top}px`, left: `${this.posicao.left}px`, width: `${this.posicao.largura}px` }
	}

	mounted() {
		window.addEventListener('resize', this.medir)
		this.acompanhar()
	}

	beforeDestroy() {
		window.removeEventListener('resize', this.medir)
		window.removeEventListener('keydown', this.segurarTeclado, true)
		window.clearInterval(this.procura)
	}

	@Watch('dono', { immediate: true })
	async consultarNovidade(dono: string | null) {
		this.respostaDoServidor = null
		if (!this.configurado || !dono) return
		try {
			const { vista } = await buscarNovidadeDoChat()
			if (this.dono === dono) this.respostaDoServidor = { dono, vista: vista === true }
		} catch (erro) {
			// Sem resposta do ERP o destaque fica de fora: melhor não mostrar do que mostrar a quem já viu
		}
	}

	@Watch('elegivel')
	aoMudarElegibilidade() {
		this.acompanhar()
	}

	// Abrir o chat por qualquer caminho (barra, menu "?" ou bolha) conta como já ter usado
	@Watch('painelAberto')
	aoAbrirOChat(aberto: boolean) {
		if (aberto) this.marcarComoVisto()
	}

	@Watch('visivel')
	aoMostrar(visivel: boolean) {
		if (visivel) {
			window.addEventListener('keydown', this.segurarTeclado, true)
			this.$nextTick(this.focarEntendi)
		} else {
			window.removeEventListener('keydown', this.segurarTeclado, true)
		}
	}

	focarEntendi() {
		const botao = this.$refs.entendi as HTMLElement | undefined
		if (botao) botao.focus()
	}

	/**
	 * Com o destaque na tela, o teclado não chega aos atalhos do sistema e o Tab fica no "Entendi". Enter e espaço
	 * no botão seguem funcionando: a ação padrão do botão não depende da propagação.
	 */
	segurarTeclado(evento: KeyboardEvent) {
		evento.stopPropagation()
		if (evento.key === 'Tab') {
			evento.preventDefault()
			this.focarEntendi()
		}
	}

	acompanhar() {
		window.clearInterval(this.procura)
		if (!this.elegivel) {
			this.alvo = null
			return
		}
		this.medir()
		// O ícone nasce com a barra de cada tela e pode mudar de lugar: segue medindo enquanto o destaque valer
		this.procura = window.setInterval(this.medir, PROCURA_DO_ICONE_MS)
	}

	medir() {
		this.larguraDaTela = window.innerWidth
		// Com um diálogo aberto (alerta de versão, primeiro acesso), o destaque espera ele fechar
		const dialogoAberto = document.querySelector('.v-dialog__content--active') !== null
		const caixa = dialogoAberto
			? undefined
			: Array.from(document.querySelectorAll<HTMLElement>('[data-chat-suporte-icone]'))
				.map(icone => icone.getBoundingClientRect())
				.find(retangulo => retangulo.width > 0 && retangulo.height > 0)
		const novo = caixa ? { top: caixa.top, left: caixa.left, width: caixa.width, height: caixa.height } : null
		const atual = this.alvo
		const igual = !!novo && !!atual
			&& novo.top === atual.top && novo.left === atual.left
			&& novo.width === atual.width && novo.height === atual.height
		if (!igual && (novo || atual)) this.alvo = novo
	}

	/**
	 * "Entendi", ou o chat aberto por qualquer caminho. Grava mesmo com a consulta ainda em andamento, porque abrir o
	 * chat antes da resposta também conta; marcar de novo não faz mal, o ERP ignora a repetição.
	 */
	marcarComoVisto() {
		const dono = this.dono
		const resposta = this.respostaDoServidor
		if (!dono || this.vistosNestaAba.includes(dono) || (resposta && resposta.dono === dono && resposta.vista)) return
		this.vistosNestaAba = [...this.vistosNestaAba, dono]
		// Se a gravação falhar, o destaque volta no próximo acesso: o mesmo que o usuário nunca ter visto
		marcarNovidadeDoChatComoVista().catch(() => undefined)
	}
}
